// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3CuX3","boxTitle":"Qualiphy_boxTitle__2t1YM","box":"Qualiphy_box__RPpak","toggleWrap":"Qualiphy_toggleWrap__3_t4y"};